<template>
  <div id="questionnaireAnswerDetails" v-if="divVisible">
    <b>評価結果詳細画面</b><br/><br/>

    <table class="table icon">
      <tr>
        <td>直近評価結果詳細を参照いただきます。</td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader0" class="table table-striped">
          <tbody>
            <tr>
              <td><b>評価項目：</b></td>
              <td>{{ rows[0].questionnaireID }}</td>
            </tr>
            <tr>
              <td><b>被評価：</b></td>
              <td>{{ rows[0].player1MemberID }}</td>
            </tr>
          </tbody>
        </table>
      </div><br/><br/>

      <div align="right">
        <button v-if="!showFlg" @click="showFlg = !showFlg;">≫</button>
        <button v-if=" showFlg" @click="showFlg = !showFlg;">≪</button>
      </div>

      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;margin-bottom:10px;width: 100%;">
        <table id="rptHeader" class="table table-striped">
          <thead>
            <tr v-for="(head, index) in heads" v-bind:key="'head' + index">
              <td v-if="showFlg">{{ head.sequence }}<br/>{{ head.appraiserMemberID }}</td>
              <td >{{ head.player1MemberID }}</td>
              <td v-if="showFlg">{{ head.player1ProjectID }}</td>
              <td v-if="showFlg">{{ head.player1YearMonth }}</td>
              <td>{{ head.player1AccumulateScoreOld }}</td>
              <td v-if="showFlg">{{ head.player1EloE }}</td>
              <td>{{ head.player1Score }}</td>
              <td>{{ head.player1AccumulateScoreNew }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" v-bind:key="'row' + index">
              <td v-if="showFlg">{{ row.sequence }}<br/>{{ row.appraiserMemberID }}</td>
              <td ><b>{{ row.player1MemberID }}</b><br/>{{ row.player2MemberID }}</td>
              <td v-if="showFlg"><b>{{ row.player1ProjectID }}</b><br/>{{ row.player2ProjectID }}</td>
              <td v-if="showFlg"><b>{{ row.player1YearMonth }}</b><br/>{{ row.player2YearMonth }}</td>
              <td><b>{{ row.player1AccumulateScoreOld }}</b><br/>{{ row.player2AccumulateScoreOld }}</td>
              <td v-if="showFlg"><b>{{ row.player1EloE }}</b><br/>{{ row.player2EloE }}</td>
              <td><b>{{ row.player1Score }}</b><br/>{{ row.player2Score }}</td>
              <td><b>{{ row.player1AccumulateScoreNew }}</b><br/>{{ row.player2AccumulateScoreNew }}</td>
            </tr>
          </tbody>
        </table>
      </div><br/>
      <button @click="$router.back(-1);" class="btn-mid" style="width:250px;">キャンセル</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "questionnaireAnswerDetails",
    data() {
      return {
          divVisible: false,
          showFlg: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          heads: [ { sequence: '', questionnaireID: '', appraiserMemberID: '',
                     player1MemberID: '', player1ProjectID: '', player1YearMonth: '', player1Score: '',
                     player2MemberID: '', player2ProjectID: '', player2YearMonth: '', player2Score: '',
                     player1EloQ: '', player1EloE: '', player1AccumulateScoreOld: '', player1AccumulateScoreNew: '',
                     player2EloQ: '', player2EloE: '', player2AccumulateScoreOld: '', player2AccumulateScoreNew: '',
                     createDate: '', modifiedDate: '',
                 } ],
          rows:  [ { sequence: '', questionnaireID: '', appraiserMemberID: '',
                     player1MemberID: '', player1ProjectID: '', player1YearMonth: '', player1Score: '',
                     player2MemberID: '', player2ProjectID: '', player2YearMonth: '', player2Score: '',
                     player1EloQ: '', player1EloE: '', player1AccumulateScoreOld: '', player1AccumulateScoreNew: '',
                     player2EloQ: '', player2EloE: '', player2AccumulateScoreOld: '', player2AccumulateScoreNew: '',
                     createDate: '', modifiedDate: '',
                 } ],
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/QuestionnaireAnswerDetailsInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                self.heads = res.data.heads;
                self.rows = res.data.rows;



                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });

      },
    },

  };
</script>



// WEBPACK FOOTER //
// questionnaireAnswerDetails.vue?1fbefd66